import React from "react";

import { useAuth } from "../../context/AuthContext";
import type { WorkspaceId } from "../../utils/workspaceStorage";
import AccountSidebar from "../EventOS/AccountSidebar";
import { LiveTeamMembersPanel } from "../EventOS/components/LiveTeamMembersPanel";
import "../EventOS/EventOSPage.css";

type Props = {
  workspace: WorkspaceId;
};

const ProfilePage: React.FC<Props> = () => {
  const { token, setSession } = useAuth();

  // The gate team is company-wide, so there is no event to pick here.
  const teamPanel = (
    <div className="eventos-profile-team-gate">
      {token ? (
        <LiveTeamMembersPanel token={token} compact />
      ) : (
        <div className="eventos-empty">Sign in to manage your team.</div>
      )}
    </div>
  );

  return (
    <div className="eventos-profile-page eventos-profile-page--fit">
      <div className="eventos-profile-head">
        <h1 className="app-shell-page-title">Profile &amp; Settings</h1>
        <p className="app-shell-lede eventos-profile-lede">
          Update your profile, password, GST info, settings, and manage your team.
        </p>
      </div>

      <div className="eventos-profile-scroll">
        <AccountSidebar rightExtra={teamPanel} />
      </div>

      <div className="eventos-profile-logout-row">
        <button className="eventos-profile-logout-btn" type="button" onClick={() => setSession(null)}>
          Log out
        </button>
      </div>
    </div>
  );
};

export default ProfilePage;
